import { parseUserRole } from '@app/components/UsageLimitationBanner/utils/parseUserRole'
import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

import type { Surface } from './hooks/types'

const VALID_SURFACES: readonly Surface[] = ['automations', 'workflows', 'tasks']
const isSurface = (value: string): value is Surface =>
	(VALID_SURFACES as readonly string[]).includes(value)

const AppProviders = lazy(() => import('@app/components/AppProviders'))
const ProAiUpsellTag = lazy(() =>
	import('./ProAiUpsellTag').then((m) => ({ default: m.ProAiUpsellTag })),
)

class ProAiUpsellTagWebComponent extends ReactWebComponent {
	static get observedAttributes() {
		return ['team-uuid', 'project-id', 'surface', 'user-role']
	}

	override render() {
		const rawSurface = this.prop('surface') || 'automations'
		const surface: Surface = isSurface(rawSurface) ? rawSurface : 'automations'
		const userRole = parseUserRole(this.prop('user-role'))

		return (
			<AppProviders>
				<ProAiUpsellTag
					teamUuid={this.prop('team-uuid')}
					projectId={this.prop('project-id')}
					surface={surface}
					userRole={userRole}
				/>
			</AppProviders>
		)
	}
}

customElements.define('pro-ai-upsell-tag', ProAiUpsellTagWebComponent)

export { ProAiUpsellTagWebComponent }
